/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PolicyDocumentType;

(function (PolicyDocumentType) {
  PolicyDocumentType["WOR"] = "WOR";
  PolicyDocumentType["SOC"] = "SOC";
  PolicyDocumentType["SCH"] = "SCH";
  PolicyDocumentType["QSCH"] = "QSCH";
  PolicyDocumentType["SOF"] = "SOF";
  PolicyDocumentType["IPD"] = "IPD";
  PolicyDocumentType["CER"] = "CER";
  PolicyDocumentType["IPID"] = "IPID";
  PolicyDocumentType["PI"] = "PI";
  PolicyDocumentType["TOBA"] = "TOBA";
  PolicyDocumentType["INVOICE"] = "INVOICE";
  PolicyDocumentType["UNSPECIFIED"] = "UNSPECIFIED";
  PolicyDocumentType["CANCEL"] = "CANCEL";
  PolicyDocumentType["APPLICATION_FORMS"] = "APPLICATION_FORMS";
  PolicyDocumentType["SIGNED"] = "SIGNED";
  PolicyDocumentType["UPLOAD"] = "UPLOAD";
})(PolicyDocumentType || (PolicyDocumentType = {}));